import { GeneralLookupsApi } from 'api/general-lookups';
import { autoinject } from 'aurelia-framework';
import { tryExecute } from 'framework/error_handling/error-utils';
import { AutocompleteOptions } from 'framework/html_behaviors/af-autocomplete';
import { ServiceBase } from 'support/base_classes/service-base';
import * as E from 'support/errors';
import { LOOKUPS_DEBOUNCE } from 'support/settings';
import { Country } from '../model/business-keywords';
import { KeywordsService } from './keywords-service';

@autoinject
export class LookupsService extends ServiceBase {
  constructor(private keywords: KeywordsService, private api: GeneralLookupsApi) {
    super();
  }

  protected get runtimeDependencies(): ServiceBase[] {
    return [this.keywords];
  }

  getUsersLookupOptions(): AutocompleteOptions {
    return ({ getItems: (text: string) => this.loadItems(() => this.api.lookupUsers({ text: text })), minLength: 3, debounceMs: LOOKUPS_DEBOUNCE });
  }

  getCitiesLookupOptions(): AutocompleteOptions {
    return ({ getItems: (text: string) => this.loadItems(() => this.api.lookupCities({ text: text })), minLength: 1, debounceMs: LOOKUPS_DEBOUNCE });
  }

  getAirlinesLookupOptions(): AutocompleteOptions {
    return ({ getItems: async (text: string) => (text = this.normalizeFilter(text)) != null ? this.keywords.airlines.filter(i => this.matchesFilter(text, i.name, i.code)) : this.keywords.airlines, minLength: 0, debounceMs: 0, showOnFocus: true });
  }

  getSitesLookupOptions(country: Country): AutocompleteOptions {
    return ({
      getItems: async (text: string) => {
        const sites = country ? this.keywords.sites.filter(x => x.country.id === country.id) : this.keywords.sites;
        return (text = this.normalizeFilter(text)) != null ? sites.filter(i => this.matchesFilter(text, i.name, i.address)) : sites;
      }
      , minLength: 0, debounceMs: 0, showOnFocus: true
    });
  }

  private normalizeFilter(filter: string) {
    return (filter = filter?.trim().toLowerCase()) !== '' ? filter : null;
  }

  private matchesFilter(normalizedFilter: string, ...content: string[]) {
    return normalizedFilter == null || content.some(c => c != null && c.toLowerCase().includes(normalizedFilter));
  }

  private loadItems<T>(loader: () => Promise<T>) {
    return tryExecute(() => loader(), E.LOOKUP_ERROR_MESSAGE, E.LOOKUP_ERROR_TITLE, true);
  }
}
